<template>
    <div class="button-container">
        <button :type="type" :id="id" :disabled="isLoading" class="button" :class="color == 'primary' ? 'bg-gradient-to-r from-light-blue to-green' : 'bg-white/20'">{{ isLoading ? "Loading..." : label }}</button>
    </div>
</template>

<script>

export default {
    name: "ButtonComponent",
    props: {
        type: { type: String, default: "button" }, // Accepting a "type" property
        color: { type: String, default: "primary" }, // Accepting a "color" property to set the overall style of the button
        name: { type: String, default: "name" },
        label: { type: String, default: "" },
        isLoading: { type: Boolean, default: false }, // Sets the state of the button to be "loading"
        id: { type: String, default: "" }
    },
    components: {

    },
    computed: {},
    data: function () {
        return {};
    },
    methods: {
    },
};
</script>
